import * as React from 'react';

import _t from 'i18n!nls/discussions';

import { ShimmerState } from '../../../ForumThread';
import PaginationState, { PaginationStateConsumer } from '../../../__components/PaginationState';
import type { PaginationStateRenderProps } from '../../../__components/PaginationState/__types__';
import { Providers } from '../../../__providers__/ForumPostDataProvider';
import type { ForumAnswersDataProviderResponse } from '../../../__providers__/ForumPostDataProvider/__types__';

type PaginatedAnswersRenderProps = PaginationStateRenderProps & ForumAnswersDataProviderResponse;

type Props = {
  id: string;
  limit: number;
  sortOrder?: string;
  children: (props: PaginatedAnswersRenderProps) => JSX.Element | null;
};

const PaginatedAnswersDataProvider = (props: Props) => {
  const { id, limit, sortOrder, children } = props;

  return (
    <PaginationState routerParamPage="page" routerParamLimit="limit" initialLimit={limit}>
      <PaginationStateConsumer>
        {({
          page: paginatedPage,
          limit: paginatedLimit,
          setPage,
          setLimit,
        }: PaginationStateRenderProps & { setPage: (n: number) => {} }) => (
          <Providers.Answers forumQuestionId={id} limit={paginatedLimit} page={paginatedPage} sortOrder={sortOrder}>
            {({ loading, error, data }) => {
              const replies = data?.replies;
              if (loading) {
                return <ShimmerState />;
              }
              if (error) {
                return <section>{_t('oops something went wrong')}</section>;
              }
              if (data && data.replies) {
                return children({ page: paginatedPage, limit: paginatedLimit, setPage, setLimit, replies });
              }
              return null;
            }}
          </Providers.Answers>
        )}
      </PaginationStateConsumer>
    </PaginationState>
  );
};

export default PaginatedAnswersDataProvider;
